import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { DisplayText, theme } from '@sg/garnish';
import { MenuCategoryBadge } from '@sg/shared-fe/features/menu';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridCategoryHeading = (props: Props) => {
  const { children, badge } = props;

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['40']}>{children}</DisplayText>
      {badge ? <MenuCategoryBadge>{badge}</MenuCategoryBadge> : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing['2'],
    marginBottom: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  badge?: string;
}>;
